export const mainQuestionContentId = 'mainQuestionContent' as const;
